// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"40":"20d6bb02fec47021","3091":"e6a3d1cf66f0ddf4","3283":"29acb5bdccbbe8f4"}[chunkId] + ".css";
};